module.exports = __webpack_public_path__ + "static/cloud_computing-33d2b5a89f884e053a5a5ce601fd455c.jpg";